import { render, staticRenderFns } from "./LandRegister.vue?vue&type=template&id=e2ec7776"
import script from "./LandRegister.vue?vue&type=script&lang=js"
export * from "./LandRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports